import httpManager from "@/app/shared/utils/httpManager";

/**
 * Exportar contactos a hubspot.
 *
 */
export async function getHomologatedFields(clientIds) {
  const response = await httpManager.post(`/hubspot/clients/homologated-fields/`, 
    {
      client_ids: clientIds,
    }
  );
  return response?.data;
}
